import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

type LayoutState = {
  showNavigation: boolean;
  pagePadding: boolean;
  showBlindspotAccountSearch: boolean;
};

const initialState: LayoutState = {
  showNavigation: true,
  pagePadding: true,
  showBlindspotAccountSearch: true,
};

export const LayoutStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setShowNavigation(showNavigation: boolean): void {
      patchState(store, { showNavigation });
    },
    setPadding(pagePadding: boolean): void {
      patchState(store, { pagePadding });
    },
    setShowBlindspotAccountSearch(showBlindspotAccountSearch: boolean): void {
      patchState(store, { showBlindspotAccountSearch });
    },
  })),
);
